/**
 * TYPES
 */
import {IAiAgent} from 'src/aggregates/ai/state.d';
import {IAiAgentsById} from 'src/aggregates/ai/state.d';
import {_aggregates} from 'src/aggregates/index.d';
import {IEvent} from 'src/aggregates/index.d';


/**
 * EXPORTS
 */

// Events types
export enum types
{
    AI_AGENTS_ADDED_TO_TRAINING = 'AI_AGENTS_ADDED_TO_TRAINING',
    AI_AGENTS_ADDING_TO_TRAINING = 'AI_AGENTS_ADDING_TO_TRAINING',
    AI_AGENTS_DELETING_UNANSWERED = 'AI_AGENTS_DELETING_UNANSWERED',
    AI_AGENTS_FETCHED_ONE = 'AI_AGENTS_FETCHED_ONE',
    AI_AGENTS_FETCHING_ONE = 'AI_AGENTS_FETCHING_ONE',
    AI_AGENTS_IMPLANTED = 'AI_AGENTS_IMPLANTED',
    AI_AGENTS_IMPLANTING = 'AI_AGENTS_IMPLANTING',
    AI_AGENTS_LISTED = 'AI_AGENTS_LISTED',
    AI_AGENTS_LISTING = 'AI_AGENTS_LISTING',
    AI_AGENTS_NOT_ADDED_TO_TRAINING = 'AI_AGENTS_NOT_ADDED_TO_TRAINING',
    AI_AGENTS_NOT_FETCHED_ONE = 'AI_AGENTS_NOT_FETCHED_ONE',
    AI_AGENTS_NOT_IMPLANTED = 'AI_AGENTS_NOT_IMPLANTED',
    AI_AGENTS_NOT_LISTED = 'AI_AGENTS_NOT_LISTED',
    AI_AGENTS_NOT_UPDATED = 'AI_AGENTS_NOT_UPDATED',
    AI_AGENTS_UNANSWERED_DELETED = 'AI_AGENTS_UNANSWERED_DELETED',
    AI_AGENTS_UNANSWERED_NOT_DELETED = 'AI_AGENTS_UNANSWERED_NOT_DELETED',
    AI_AGENTS_UPDATED = 'AI_AGENTS_UPDATED',
    AI_AGENTS_UPDATING = 'AI_AGENTS_UPDATING',
}


// Events interfaces
export interface IAiAgentsAddedToTraining extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_ADDED_TO_TRAINING;
    aiAgent: IAiAgent;
    type: types.AI_AGENTS_ADDED_TO_TRAINING;
}

export interface IAiAgentsAddingToTraining extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_ADDING_TO_TRAINING;
    type: types.AI_AGENTS_ADDING_TO_TRAINING;
}

export interface IAiAgentsDeletingUnanswered extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_DELETING_UNANSWERED;
    type: types.AI_AGENTS_DELETING_UNANSWERED;
}

export interface IAiAgentsFetchedOne extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_FETCHED_ONE;
    aiAgent: IAiAgent;
    type: types.AI_AGENTS_FETCHED_ONE;
}

export interface IAiAgentsFetchingOne extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_FETCHING_ONE;
    type: types.AI_AGENTS_FETCHING_ONE;
}

export interface IAiAgentsImplanted extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_IMPLANTED;
    aiAgent: IAiAgent;
    type: types.AI_AGENTS_IMPLANTED;
}

export interface IAiAgentsImplanting extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_IMPLANTING;
    type: types.AI_AGENTS_IMPLANTING;
}

export interface IAiAgentsListed extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_LISTED;
    byId: IAiAgentsById;
    type: types.AI_AGENTS_LISTED;
}

export interface IAiAgentsListing extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_LISTING;
    type: types.AI_AGENTS_LISTING;
}

export interface IAiAgentsNotAddedToTraining extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_NOT_ADDED_TO_TRAINING;
    type: types.AI_AGENTS_NOT_ADDED_TO_TRAINING;
}

export interface IAiAgentsNotFetchedOne extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_NOT_FETCHED_ONE;
    type: types.AI_AGENTS_NOT_FETCHED_ONE;
}

export interface IAiAgentsNotImplanted extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_NOT_IMPLANTED;
    type: types.AI_AGENTS_NOT_IMPLANTED;
}

export interface IAiAgentsNotListed extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_NOT_LISTED;
    type: types.AI_AGENTS_NOT_LISTED;
}

export interface IAiAgentsNotUpdated extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_NOT_UPDATED;
    type: types.AI_AGENTS_NOT_UPDATED;
}

export interface IAiAgentsUnansweredDeleted extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_UNANSWERED_DELETED;
    messageId: string;
    type: types.AI_AGENTS_UNANSWERED_DELETED;
}

export interface IAiAgentsUnansweredNotDeleted extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_UNANSWERED_NOT_DELETED;
    type: types.AI_AGENTS_UNANSWERED_NOT_DELETED;
}

export interface IAiAgentsUpdated extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_UPDATED;
    aiAgent: IAiAgent;
    type: types.AI_AGENTS_UPDATED;
}

export interface IAiAgentsUpdating extends IEvent
{
    _aggregate: _aggregates.AI;
    _name: types.AI_AGENTS_UPDATING;
    type: types.AI_AGENTS_UPDATING;
}
